module.exports = __webpack_public_path__ + "static/media/home3.adb6e323.png";